import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { TemplateDataTable } from "./TemplateDataTable";
import { WHATSAPP_TEMPLATE_LIST } from "../../../constants/ServiceConstants";
import api from "../../../axios/Axios";
import Axios from "../../../axios/Axios";
import { HOST_URL } from "../api/Api";
import Delete from "../../UI/Table/compopents/cell/Delete";
import styles from "./WhatsappTemplateNew.module.css";

const WhatsappTemplate = () => {
  const login = JSON.parse(localStorage.getItem("login"));
  const userId = login?.user?.userId;
  const token = login?.token;

  const [route, setRoute] = useState(null);
  const [healthData, setHealthData] = useState(null);

  /* ROUTE FETCH */
  useEffect(() => {
    Axios.post(`${HOST_URL}/get_user_route.php`, {
      user_id: userId,
      method: "retrieve",
      token,
    }).then((res) => {
      if (res.data?.success) setRoute(res.data.data);
    });
  }, [userId, token]);

  /* DATA FETCH */
  const fetchWhatsappTemplates = useCallback(
    async ({ page, limit }) => {
      const { data } = await api.post(WHATSAPP_TEMPLATE_LIST, {
        token,
        user_id: userId,
        method: "retrieve",
      });

      if (!data?.success) return { data: [], total: 0 };

      const rows = data.data || [];
      const start = (page - 1) * limit;

      return {
        data: rows.slice(start, start + limit),
        total: rows.length,
      };
    },
    [userId, token]
  );

  /* HEALTH CHECK */
  const checkHealth = async (id) => {
    const { data } = await Axios.post(`${HOST_URL}/wp_profile.php`, {
      user_id: userId,
      token,
      method: "check_template_status",
      template_id: id,
    });

    if (data.success) setHealthData(data.message);
  };

  /* FRESH REPLY */
  const toggleFresh = async (row) => {
    await fetch(`${HOST_URL}/whatsapp_template.php`, {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token,
        user_id: userId,
        method: "add_freshreply",
        id: row.id,
        value: row.fresh_reply === 0 ? 1 : 0,
      }),
    });
    window.location.reload();
  };

  /* STATUS BADGE */
  const statusBadge = (row) => {
    const map = {
      0: "pending",
      1: "approved",
      2: "draft",
      5: "review",
    };
    const key = map[row.temp_status] || "rejected";
    return <span className={`${styles.badge} ${styles[key]}`}>{key.toUpperCase()}</span>;
  };

  /* ACTION COLUMN */
  const actionCell = (row) => (
    <div className={styles.actions}>
      <Link to={`/dashboard/preview-whatsapp-template/${row.id}`}>
        <span className={styles.view}>View</span>
      </Link>

      <Link to={`/dashboard/duplicate-whatsapp-template/${row.id}`}>
        <span className={styles.copy}>Copy</span>
      </Link>

      <Delete id={row.id} name={row.temp_name} />

      <span onClick={() => checkHealth(row.facebook_tempid)} className={styles.health}>
        Health
      </span>
    </div>
  );

  /* TABLE COLUMNS */
  const columns = [
    { key: "id", label: "WID", width: "80px", render: (r) => r.id },
   {
  key: "temp_name",
  label: "Template Name",
  width: "260px",
  render: (r) => (
    <div className={styles.templateCell}>
      <div className={styles.templateName}>{r.temp_name}</div>

      <div className={styles.meta}>{r.brand_number}</div>

      <div className={styles.badgeApproved}>
        {r.temp_status === 1 ? "APPROVED" : "PENDING"}
      </div>

      <div className={styles.meta}>{r.created}</div>
    </div>
  ),
},
    { key: "temp_category", label: "Category", render: (r) => r.temp_category },
    { key: "temp_type", label: "Type", render: (r) => r.temp_type },
    {
      key: "dynamic_content",
      label: "Dynamic",
      render: (r) => (r.dynamic_content ? "Yes" : "No"),
    },
 {
  key: "action",
  label: "Action",
  width: "260px",
  render: (r) => (
    <div className={styles.actionBar}>
      <Link to={`/dashboard/preview-whatsapp-template/${r.id}`}>
        <span className={`${styles.actionBtn} ${styles.view}`}>View</span>
      </Link>

      <Link to={`/dashboard/duplicate-whatsapp-template/${r.id}`}>
        <span className={`${styles.actionBtn} ${styles.copy}`}>Copy</span>
      </Link>

      <span className={`${styles.actionBtn} ${styles.delete}`}>
        Delete
      </span>

      <span
        onClick={() => checkHealth(r.facebook_tempid)}
        className={`${styles.actionBtn} ${styles.health}`}
      >
        Health
      </span>
    </div>
  ),
},
  {
  key: "fresh_reply",
  label: "Fresh Reply",
  render: (r) => (
    <span
      onClick={() => toggleFresh(r)}
      className={
        r.fresh_reply
          ? styles.freshRemove
          : styles.freshAdd
      }
    >
      {r.fresh_reply ? "Remove" : "Add"}
    </span>
  ),
},
  ];

  return (
    <>
      <TemplateDataTable
        columns={columns}
        fetchData={fetchWhatsappTemplates}
        pageSize={5}
        flags={{ pagination: true }}
      />

      {healthData && (
        <div className={styles.modal}>
          <div className={styles.modalBox}>
            <h4>Health Status</h4>
            <pre>{JSON.stringify(healthData, null, 2)}</pre>
            <button onClick={() => setHealthData(null)}>Close</button>
          </div>
        </div>
      )}
    </>
  );
};

export default WhatsappTemplate;
